<template>
  <div>
    <div class="o-panel" v-if="open" v-bind:class="{ 'o-panel--open': this.open }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ title }}</h2>
        <button type="button" class="o-panel__close" @click="close">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <div class="h-remove-child-margin">
          <p>
            <textarea v-model="json" :style="{ width: '100%', height: '200px', resize: 'none' }" readonly />
          </p>
          <p class="confirmation-popup__actions">
            <button class="a-btn-primary" @click="copy" type="button">{{ $t('report-json-copy') }}</button>
            <br />
            <span v-if="showCopyConfirmationMessage" v-html="$t('report-json-copy-confirmation')" />
          </p>
        </div>
      </div>
    </div>
    <div class="o-panel__overlay" @click="close"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCopyConfirmationMessage: false
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    json: {
      type: String,
      required: true
    }
  },
  computed: {
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },
  methods: {
    close: function() {
      this.showCopyConfirmationMessage = false
      this.$emit('close')
    },
    copy: async function() {
      navigator.clipboard.writeText(this.json)
      this.showCopyConfirmationMessage = true
    }
  }
}
</script>
